import React from 'react'
import { numberFormatter } from '../../../helpers'
import clsx from 'clsx'

const strikeClass = ''

export function FarePrice({isFree, currencyCode, amount}: { isFree: boolean, currencyCode: string, amount: number }) {
  const formatted = numberFormatter.formatCurrency(amount)
  const splitted = numberFormatter.decimalSplitter(formatted)
  return (
    <div className={clsx('tw-relative', (isFree ? strikeClass : ''))}>
      <span className='tw-text-md'>{currencyCode}&nbsp;</span>
      <span className='tw-text-3xl'>{splitted.amount}</span>
      <span
        className='tw-text-lg'>{numberFormatter.oneDecimalPoint(splitted.decimal, currencyCode)}</span>
    </div>
  )
}

export function BaseFarePrice({currencyCode, amount}: { currencyCode: string, amount: number }) {
  const formatted = numberFormatter.formatCurrency(amount)
  const splitted = numberFormatter.decimalSplitter(formatted)
  return (
    <div className="tw-text-xs tw-line-through sa-text-green">
      <span>{currencyCode}&nbsp;</span>
      <span>{splitted.amount}</span>
      <span>{numberFormatter.oneDecimalPoint(splitted.decimal, currencyCode)}</span>
    </div>
  )
}